import ParentIncome from './ParentIncome';
import moment from 'moment';

export default class ChildParentIncome {
    constructor() {
        this.highestRate = 'none';
        this.parentIncome1 = new ParentIncome();
        this.parentIncome2 = new ParentIncome();
    }

    isActive() {
        return this.status === 1;
    }

    isHighestRateNone() {
        return this.highestRate === 'none';
    }

    sumIncome1() {
        let sum = 0;
        if (this.parentIncome1) {
            sum += this.parentIncome1.sum();
        }
        return sum;
    }

    sumIncome2() {
        let sum = 0;
        if (this.parentIncome2) {
            sum += this.parentIncome2.sum();
        }
        return sum;
    }

    sum() {
        let sum = 0;
        if (this.parentIncome1) {
            sum += this.parentIncome1.sum();
        }
        if (this.parentIncome2) {
            sum += this.parentIncome2.sum();
        }
        return sum;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        const childParentIncome = new ChildParentIncome();
        childParentIncome.id = data.id;
        childParentIncome.created = moment(data.created, 'YYYY-MM-DD').format('DD.MM.YYYY');
        childParentIncome.start = moment(data.start, 'YYYY-MM-DD').format('DD.MM.YYYY');
        childParentIncome.status = data.status;
        childParentIncome.highestRate = data.highestRate;
        childParentIncome.parentIncome1 = ParentIncome.fromData(data.parentIncome1.data);
        childParentIncome.parentIncome2 = ParentIncome.fromData(data.parentIncome2.data);

        Object.seal(childParentIncome);
        return childParentIncome;
    }
}
